<section class="container-fluid newsslider-container">
    <div class="row">
        <div class="newsslider-wrapper container space">
            <h1 class="headline">Allgemeine News</h1>
            <div class="row flex">
                <div class="col-xs-12 col-sm-4 col-md-4 col-lg-3 slider-tsr-wrapper ">
                    <article class="slider-tsr-container">
                        <div class="slider-tsr-img">
                            <picture>
                                <source media="(min-width: 992px)"
                                        srcset="/assets/img/home/slider/lg/audi_fis_alpine_ski_world_cup.jpg">
                                <source media="(min-width: 480px)"
                                        srcset="/assets/img/home/slider/sm/audi_fis_alpine_ski_world_cup.jpg">
                                <source media="(min-width: 0px)"
                                        srcset="/assets/img/home/slider/xs/audi_fis_alpine_ski_world_cup.jpg">
                                <img class="img-responsive"
                                     src="assets/img/home/slider/lg/audi_fis_alpine_ski_world_cup.jpg"
                                     alt="Alexander Koenig">
                            </picture>
                        </div>
                        <div class="slider-tsr-content">
                            <h2>Audi FIS Alpine Ski World Cup</h2>
                            <p>In Garmisch-Partenkirchen ging es Anfang Februar rund, denn der Ski-Weltcup wurde an zwei
                                Wochenenden auf der legendären Kandahar-Rennstrecke bei mildem Wetter ausgetragen.</p>
                        </div>
                        <a class="more" routerLink="./news/skiworldcup">mehr...</a>

                    </article>
                </div>
                <div class="col-xs-12 col-sm-4 col-md-4 col-lg-3 slider-tsr-wrapper ">
                    <article class="slider-tsr-container">
                        <div class="slider-tsr-img">
                            <picture>
                                <source media="(min-width: 992px)"
                                        srcset="/assets/img/home/slider/md/muenchner_sommernachtstraum.jpg">
                                <source media="(min-width: 480px)"
                                        srcset="/assets/img/home/slider/sm/muenchner_sommernachtstraum.jpg">
                                <source media="(min-width: 0px)"
                                        srcset="/assets/img/home/slider/xs/muenchner_sommernachtstraum.jpg">
                                <img class="img-responsive" src="assets/img/home/slider/lg/muenchner_sommernachtstraum.jpg"
                                     alt="Münchner Sommernachtstraum">
                            </picture>
                        </div>
                        <div class="slider-tsr-content">
                            <h2>Münchner- Sommernachtstraum</h2>
                            <p> Bald ist es soweit - am 20.7. leuchtet der Nachthimmel beim Münchner Sommernachtstraum.
                                Wir
                                haben Infos zum Megaevent im Olympiapark zusammengestellt. </p>
                        </div>
                        <a class="more" routerLink="photography/muenchner_sommernachtstraum">mehr...</a>
                    </article>
                </div>
                <div class="col-xs-12 col-sm-4 col-md-4 col-lg-3 slider-tsr-wrapper">
                    <article class="slider-tsr-container">
                        <div class="slider-tsr-img">
                            <picture>
                                <source media="(min-width: 992px)"
                                        srcset="/assets/img/home/slider/lg/sardinien_segeln.png">
                                <source media="(min-width: 480px)"
                                        srcset="/assets/img/home/slider/lg/sardinien_segeln.png">
                                <source media="(min-width: 0px)"
                                        srcset="/assets/img/home/slider/xs/sardinien_segeln.png">
                                <img class="img-responsive" src="assets/img/home/slider/lg/sardinien_segeln.png"
                                     alt="Alexander Koenig">
                            </picture>
                        </div>
                        <div class="slider-tsr-content">
                            <h2>Segeln zwischen Sardinien und Korsika</h2>
                            <p>Zum ersten Mal, bin ich mit einem Segelveranstalter zwischen Sardinien und Korsika
                                gesegelt.
                                <br/> Dabei habe ich viele beeindruckende Momente erlebt und fotografisch festgehalten.
                            </p>
                        </div>
                        <a class="more" routerLink="photography/sailing">mehr...</a>
                    </article>
                </div>
                <div class="col-xs-12 col-sm-6 hidden-md col-lg-3 slider-tsr-wrapper">
                    <article class="slider-tsr-container default">
                        <span>Weitere News kommen...</span>
                    </article>
                </div>
            </div>
        </div>
    </div>
</section>
